import React, { useState } from "react";

// Gives bookmarking a reason to bring a user back: tells them when one or
// more of their own saved artists moved up this week, instead of bookmarks
// being a one-way action nothing ever follows up on. Reuses the ranking
// nudge banner's look (App.css .ranking-nudge-banner*) rather than
// introducing new banner styling for what's the same shape of UI.
function BookmarkMoversBanner({ movers, onSelect }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed || !movers || movers.length === 0) return null;

  const shown = movers.slice(0, 3);
  const extraCount = movers.length - shown.length;

  return (
    <div className="ranking-nudge-banner ranking-nudge-banner-ready">
      <span>
        {movers.length} co-signed artist{movers.length === 1 ? "" : "s"} trending up this week:{" "}
        {/* Each name is its own link, not one "View" button that only ever
            opened the first mover regardless of which/how many were named -
            clicking "3 bookmarked artists... A, B, C" and landing only on A
            was the actual complaint this fixes. */}
        {shown.map((mover, i) => (
          <React.Fragment key={mover.artistKey || mover.artistName}>
            {i > 0 && ", "}
            <button
              type="button"
              className="ranking-nudge-mover-link"
              onClick={() => onSelect(mover.artistName)}
            >
              {mover.artistName}
            </button>
          </React.Fragment>
        ))}
        {extraCount > 0 && `, and ${extraCount} more`}
      </span>
      <button className="ranking-nudge-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
}

export default BookmarkMoversBanner;
